import { render } from "./CampaignCreate.vue?vue&type=template&id=3d206afd&ts=true"
import script from "./CampaignCreate.vue?vue&type=script&lang=ts"
export * from "./CampaignCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__